module.exports = __webpack_public_path__ + "img/Schnarchen.2b4e4dba.png";